import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useAuth, formatApiErrorDetail } from "@/lib/auth";

const inputClass =
  "w-full rounded-none border-0 border-b border-white/20 bg-transparent px-0 py-3 text-sm text-white placeholder:text-slate-500 focus-visible:border-accent focus-visible:outline-none transition-colors sm:text-base";

export const AdminLogin = () => {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center bg-ink px-6 text-white">
      <div className="noise-overlay" aria-hidden="true" />
      <div className="w-full max-w-md">
        <Link to="/" aria-label="AiCendor home" data-testid="admin-login-logo"><Logo /></Link>
        <div className="glass-panel mt-10 p-8 sm:p-10" data-testid="admin-login-panel">
          <p className="flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.3em] text-gold">
            <Lock className="h-3.5 w-3.5" /> Owner sign in
          </p>
          <h1 className="mt-6 font-display text-3xl tracking-tight">Booking dashboard</h1>
          <form onSubmit={onSubmit} className="mt-10 space-y-8" data-testid="admin-login-form">
            <div>
              <label htmlFor="admin-email" className="font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">Email</label>
              <input id="admin-email" data-testid="admin-email-input" type="email" required autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} className={inputClass} />
            </div>
            <div>
              <label htmlFor="admin-password" className="font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">Password</label>
              <input id="admin-password" data-testid="admin-password-input" type="password" required autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputClass} />
            </div>
            {error && (
              <p className="border border-red-500/40 bg-red-500/10 px-4 py-3 text-sm text-red-200" data-testid="admin-login-error">{error}</p>
            )}
            <button type="submit" data-testid="admin-login-submit" disabled={busy} className="btn-sweep btn-sweep-light flex w-full items-center justify-center gap-3 border border-accent bg-accent px-8 py-4 font-mono text-xs uppercase tracking-[0.22em] text-ink">
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : null} Sign in
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
